import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./lib/i18n";
import { bootstrapConsentDefaults } from "./lib/consent";
import { initSentry } from "./lib/sentry";

bootstrapConsentDefaults();
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
